export default "__VITE_ASSET__WFn6WXgI__"